<div class="fulfillmentLanding seed-return-wrapper sraCostSheetRetail">
  <div class="cppReturnsLandingPage margin-t20">
    <div class="row">
      <div class="col-9 margin-l0 TopSec">
        <h3>
          SRA Summer Fill Request - {{ isApproveRequest ? 'Review & Approve' : 'Review' }}
        </h3>
      </div>
    </div>

    <div class="form-sec">
      <div class="returnTop">
        <div class="row m-0 orderApproveRow">
          <div class="col-md-3 p-0">
            <div class="addBorder filter-dropdown-wrapper">
              Select Account
              <div class="custom-dropdown-container">
                <app-dropdown-multiselect [itemsData]="soldToAccountList"
                                          bindLabel="accountName"
                                          bindValue="accountNumber"
                                          [isBindValueNumeric]="true"
                                          [isShowValueInLabel]="true"
                                          [isInitiallySelectAll]="false"
                                          [selectInitialItem]="filters.soldToAccounts"
                                          (changemultiselect)="changeFilter($event, 'soldToAccounts')"
                                          class="material-select category-dropdown">
                </app-dropdown-multiselect>
                <!-- Cross icon, only visible if there is a selection -->
                <button *ngIf="filters.soldToAccounts && filters.soldToAccounts.length"
                        type="button"
                        class="clear-btn"
                        (click)="clearSoldToAccounts()"
                        title="Clear selection">
                 <i class="fa fa-times" aria-hidden="true"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="col-md-3 p-0">
            <div class="addBorder filter-dropdown-wrapper">
              Select Location
              <div class="custom-dropdown-container">
                <app-dropdown-multiselect [itemsData]="shipToAccountList"
                                          bindLabel="accountName"
                                          bindValue="accountNumber"
                                          [isBindValueNumeric]="true"
                                          [isShowValueInLabel]="true"
                                          [isInitiallySelectAll]="false"
                                          [selectInitialItem]="filters.shipToAccounts"
                                          (changemultiselect)="changeFilter($event, 'shipToAccounts')"
                                          class="material-select category-dropdown">
                </app-dropdown-multiselect>
                <button *ngIf="filters.shipToAccounts && filters.shipToAccounts.length"
                        type="button"
                        class="clear-btn"
                        (click)="clearShipToAccounts()"
                        title="Clear selection">
                 <i class="fa fa-times" aria-hidden="true"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="col-md-2 p-0">
            <div class="addBorder filter-dropdown-wrapper">
              Select Manufacturer
              <div class="custom-dropdown-container">
                <app-dropdown-multiselect [itemsData]="manufacturersList"
                                          [isShowValueInLabel]="false"
                                          [isInitiallySelectAll]="false"
                                          [selectInitialItem]="filters.manufacturers"
                                          (changemultiselect)="changeFilter($event, 'manufacturers')"
                                          class="material-select category-dropdown">
                </app-dropdown-multiselect>
                <button *ngIf="filters.manufacturers && filters.manufacturers.length"
                        type="button"
                        class="clear-btn"
                        (click)="clearManufacturers()"
                        title="Clear selection">
                 <i class="fa fa-times" aria-hidden="true"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="col-md-2 p-0">
            <div class="addBorder filter-dropdown-wrapper">
              <div class="custom-dropdown-container">
                <ng-select name="ddlStatus"
                           [(ngModel)]="filters.showAllOrders"
                           [virtualScroll]="true"
                           [closeOnSelect]="true"
                           [selectOnTab]="true"
                           [clearable]="false"
                           labelForId="name"
                           [searchable]="false"
                           data-testid="ddl-status-search"
                           [hideSelected]="true"
                           class="material-select category-dropdown">
                  <ng-option *ngFor="let option of statusList; let i = index;" [value]="option.id">
                    <span [attr.data-testid]="'ddl-status-select_'+option.column">{{option.value}}</span>
                  </ng-option>
                </ng-select>
              </div>
            </div>
          </div>
          <div class="my-auto ml-3 clearWrapper">
            <a href="Javascript:void(0);" class="clearAll" (click)="clearAllFilter()">Clear All</a>
          </div>
          <div class="btnContainer ml-auto">
            <button mat-raised-button class="btns loadBtn" color="primary" (click)="loadGridData();">Load Records</button>
          </div>
        </div>
      </div>


      <div class="col-md-12 p-0 mt-5">
        <div class="fulfill-top-sec">
          <div class="row listing-action-items">
            <div class="col-sm-4" style="padding-left: 25px !important;">
              <mat-checkbox *ngIf="isItemAvailable" #AllCheck class="custom-checkbox select-all-check"
                            [style.display]="'contents'"
                            (change)="enableCheckBoxAll(AllCheck._checked)"
                            [(ngModel)]="isAllItemSelected"></mat-checkbox>
            </div>
            <div class="col-xl-8 col-lg-8 col-md-8 text-right">
              <div class="display-ib wAuto">
                <mat-paginator #openRequestPaginator [pageSize]="masterConstants.PAGE_SIZE" [pageSizeOptions]="masterConstants.PAGE_SIZE_OPTIONS"></mat-paginator>
              </div>
            </div>
          </div>
        </div>
        <div class="tableContainer cppSulfurZincPrincingTable priceListTable" id="cppSulfurZincPrincing">
          <table mat-table #placedCPPOrdersTable [dataSource]="SroRequestOrdersDataSource" multiTemplateDataRows
                 class="matTables">
            <ng-container matColumnDef="action">
              <th mat-header-cell *matHeaderCellDef class="action-column"></th>
              <td mat-cell *matCellDef="let element" class="action-column">
                <mat-checkbox #SingleCheck class="custom-checkbox"
                              [style.display]="'contents'"
                              (change)="enableCheckBoxSingle(SingleCheck._checked)"
                              [(ngModel)]="element.isSelected"
                              [disabled]="!element.isItemEligible"></mat-checkbox>
              </td>
            </ng-container>
            <ng-container matColumnDef="account">
              <th mat-header-cell *matHeaderCellDef class="account-column"> Account </th>
              <td mat-cell *matCellDef="let element" class="account-column"> {{element.soldToAccountName}} </td>
            </ng-container>
            <ng-container matColumnDef="location">
              <th mat-header-cell *matHeaderCellDef class="account-column"> Location </th>
              <td mat-cell *matCellDef="let element" class="account-column"> {{element.shipToAccountName}} </td>
            </ng-container>
            <ng-container matColumnDef="deliveryLocation">
              <th mat-header-cell *matHeaderCellDef class="account-column"> Delivery Location </th>
              <td mat-cell *matCellDef="let element" class="account-column"> {{element.deliverToAccountName}} </td>
            </ng-container>
            <ng-container matColumnDef="manufacturer">
              <th mat-header-cell *matHeaderCellDef> Manufacturer </th>
              <td mat-cell *matCellDef="let element"> {{element.marketinBrand}} </td>
            </ng-container>
            <ng-container matColumnDef="itemNumber">
              <th mat-header-cell *matHeaderCellDef class="pb-2"> Item Number </th>
              <td mat-cell *matCellDef="let element"> {{element.itemNumber}} </td>
            </ng-container>
            <ng-container matColumnDef="productName">
              <th mat-header-cell *matHeaderCellDef class="pb-2">
                Product Name
                <div class="productFilters position-relative">
                  <mat-form-field>
                    <input matInput
                           placeholder="Product Name Filter"
                           [(ngModel)]="filteredValues.productName"
                           (ngModelChange)="filterByItemDesc($event)" />
                    <!-- Cross mark, only visible when there is text -->
                    <button *ngIf="filteredValues.productName"
                            mat-icon-button
                            type="button"
                            class="clear-btn-input"
                            (click)="clearProductNameFilter()"
                            tabindex="-1" [disableRipple]="true">
                      <i class="fa fa-times" aria-hidden="true"></i>
                    </button>
                  </mat-form-field>
                </div>
              </th>
              <td mat-cell *matCellDef="let element"> {{element.productName}} </td>
            </ng-container>            <ng-container matColumnDef="orderUOM">
              <th mat-header-cell *matHeaderCellDef>
                Order UOM
              </th>
              <td mat-cell *matCellDef="let element"> {{element.orderUOM}} </td>
            </ng-container>
            <ng-container matColumnDef="requestedQTY">
              <th mat-header-cell *matHeaderCellDef> Requested QTY </th>
              <td mat-cell *matCellDef="let element"> {{element.requestedQTY}} </td>
            </ng-container>
            <ng-container matColumnDef="releasedQTY">
              <th mat-header-cell *matHeaderCellDef> Released QTY </th>
              <td mat-cell *matCellDef="let element"> {{element.releasedQTY}} </td>
            </ng-container>
            <ng-container matColumnDef="unitPrice">
              <th mat-header-cell *matHeaderCellDef> Unit Price </th>
              <td mat-cell *matCellDef="let element">
                <span *ngIf="element.unitPrice > 0">${{element.unitPrice | number:'1.4-4'}}/{{element.pricingUnitOfMeasure}}</span>
                <span *ngIf="element.unitPrice <= 0">${{element.unitPrice | number:'1.4-4'}}</span>
              </td>
            </ng-container>
            <ng-container matColumnDef="estimatedAmount">
              <th mat-header-cell *matHeaderCellDef> Estimated Amount </th>
              <td mat-cell *matCellDef="let element"> ${{element.estimatedAmount | number:'1.4-4'}} </td>
            </ng-container>
            <ng-container matColumnDef="productLine">
              <th mat-header-cell *matHeaderCellDef class="pb-2">
                Product Line
                <div class="productFilters position-relative">
                  <mat-form-field>
                    <input matInput
                           placeholder="Product Line Filter"
                           [(ngModel)]="filteredValues.productLine"
                           (ngModelChange)="filterByProductLine($event)" />
                    <!-- Cross mark, only visible when there is text -->
                    <button *ngIf="filteredValues.productLine"
                            mat-icon-button
                            type="button"
                            class="clear-btn-input"
                            (click)="clearProductLineFilter()"
                            tabindex="-1" [disableRipple]="true">
                     <i class="fa fa-times" aria-hidden="true"></i>
                    </button>
                  </mat-form-field>
                </div>
              </th>
              <td mat-cell *matCellDef="let element"> {{element.productLine}} </td>
            </ng-container>
            <ng-container matColumnDef="productCategory">
              <th mat-header-cell *matHeaderCellDef class="pb-2">
                Product Category
                <div class="productFilters productCategory position-relative">
                  <mat-form-field>
                    <input matInput
                           placeholder="Product Category Filter"
                           [(ngModel)]="filteredValues.productCategory"
                           (ngModelChange)="filterByProductCategory($event)" />
                    <!-- Cross mark, only visible when there is text -->
                    <button *ngIf="filteredValues.productCategory"
                            mat-icon-button
                            type="button"
                            class="clear-btn-input"
                            (click)="clearProductCategoryFilter()"
                            tabindex="-1" [disableRipple]="true">
                     <i class="fa fa-times" aria-hidden="true"></i>
                    </button>
                  </mat-form-field>
                </div>
              </th>
              <td mat-cell *matCellDef="let element"> {{element.productCategory}} </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky:true;"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
          <div *ngIf="SroRequestOrdersDataSource == undefined || SroRequestOrdersDataSource?.data.length == 0"
               class="noDataMsg">
            <p>No Records found.</p>
          </div>
        </div>
      </div>
    </div>
    <div class="SeedFulfillBtnSec">
      <div class="row padding-l20 align-items-center">
        <div class="col-md-9 mobile-footer">
          <button *ngIf="isApproveRequest" mat-raised-button class="btns sraOrder" [disabled]="selectedCount == 0" data-testid="ddl-place-cpp-order" (click)="approveSraRequest()" [style.display]="'inline-block' ">Place Order</button>
          <button mat-raised-button class="btns sraOrder" data-testid="ddl-save-cpp-draft" color="primary" [style.display]="'inline-block'" (click)="navigateToLandigPage(0);">Close</button>
          <button *ngIf="isApproveRequest" mat-raised-button class="btns px-4" data-testid="ddl-display-request-details" [disabled]="!isRecordsLoaded  || !hasEligibleRecords" [style.display]="'inline-block'" (click)="openRequestDetailsSlider()">Display Request Details</button>
        </div>
        <div *ngIf="isApproveRequest" class="col-md-2 text-right">
          <span class="count">Records Selected<span>{{selectedCount}}</span></span>
        </div>
        <div *ngIf="!isApproveRequest" class="col-md-2 text-right">
          <!--<span class="count">Records Selected<span>{{selectedCount}}</span></span>-->
        </div>
      </div>
    </div>
  </div>
</div>
